import StorageDetail from "./StorageDetail";
import { useEditForm } from "../useEditForm";
import { URL, TYPE, ACTION } from "../URL";
import Button from 'react-bootstrap/Button';

export default function StorageDelete({data}) {
    const user_id   = data.id;
    const names     = [];
    const action    = ACTION.DELETE;
    const type      = TYPE.STORAGE;
    const name      = URL.STRINGS[type];
    const { handleSubmit } = useEditForm(data, names, type, action, user_id);

    return (<>
        <p>この{name}を削除してよろしいですか？</p>
        <p>※削除した{name}はもとにもどせません</p>
        <form onSubmit={handleSubmit}>
            <Button type="submit">削除する</Button>
        </form>

        <hr/>
        <StorageDetail data={data} />
    </>)
}
